var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.75h9.878l-1.936 1.942 1.058 1.058L22.5 15l-3.75-3.75-1.058 1.057 1.936 1.943H9.75v1.5z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5v-3a.748.748 0 00-.218-.532l-5.25-5.25A.75.75 0 0010.5 1.5H3A1.5 1.5 0 001.5 3v18A1.5 1.5 0 003 22.5h12a1.5 1.5 0 001.5-1.5v-1.5H15V21H3V3h6v4.5A1.5 1.5 0 0010.5 9H15v1.5h1.5zm-6-3V3.308L14.693 7.5H10.5z",
    fill: "#45464F"
  })));
}
export default SvgDocumentExport;